import PasswordGate from './PasswordGate';
import MirrormerePitchDeck from './MirrormerePitchDeck';

export default function MirrormereDeckViewer() {
  return (
    <PasswordGate
      deckSlug="mirrormere"
      deckName="e76 Mirrormere"
    >
      <MirrormerePitchDeck />
    </PasswordGate>
  );
}
